module.exports = __webpack_public_path__ + "static/Larsseit-1136099f03decc5011b7454f97f0d216.otf";